import { Timestamp } from "firebase/firestore";
import { VoucherDb } from "../database/models/VoucherDb";

export class Voucher {
    guid: string;
    key: string | null;
    redeemedByGuid: string | null;
    redeembedDate: Date | null;
    marketingConsent: boolean;
    companyGuid: string;
    productGuid: string;
    exportedDate: Date | null;

    createdDate: Date;
    lastModifiedDate: Date;
    deletedDate: Date | null;

    constructor(
        guid: string,
        key: string | null,
        redeemedByGuid: string | null,
        redeembedDate: Date | null,
        marketingConsent: boolean,
        companyGuid: string,
        productGuid: string,
        exportedDate: Date | null,
        createdDate: Date,
        lastModifiedDate: Date,
        deletedDate: Date | null,
    ) {
        this.guid = guid;
        this.key = key;
        this.redeemedByGuid = redeemedByGuid;
        this.redeembedDate = redeembedDate;
        this.marketingConsent = marketingConsent;
        this.companyGuid = companyGuid;
        this.productGuid = productGuid;
        this.exportedDate = exportedDate;
        this.createdDate = createdDate;
        this.lastModifiedDate = lastModifiedDate;
        this.deletedDate = deletedDate;
    }
}


export function VoucherToDbMapper(model: Voucher) {
    const mapped: VoucherDb = {
        guid: model.guid,
        key: model.key,
        redeemedByGuid: model.redeemedByGuid,
        redeembedDate: model.redeembedDate,
        marketingConsent: model.marketingConsent,
        companyGuid: model.companyGuid,
        productGuid: model.productGuid,
        exportedDate: model.exportedDate,
        createdDate: model.createdDate,
        lastModifiedDate: model.lastModifiedDate,
        deletedDate: model.deletedDate,
    };
    return mapped;
}

export function VoucherFromDbMapper(db: VoucherDb) {
    const mapped: Voucher = new Voucher(
        db.guid,
        db.key,
        db.redeemedByGuid,
        db.redeembedDate,
        db.marketingConsent,
        db.companyGuid,
        db.productGuid,
        db.exportedDate,
        db.createdDate,
        db.lastModifiedDate,
        db.deletedDate,
    )
    return mapped;
}